import { render } from "./InstaHomeView.vue?vue&type=template&id=6ddb790a&ts=true"
import script from "./InstaHomeView.vue?vue&type=script&lang=ts"
export * from "./InstaHomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__